// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M3 1H21V7H3V1Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M3 8.99561H21V23H3V8.99561ZM11 14.9978V12.9978H7V14.9978H11ZM17 14.9978V12.9978H13V14.9978H17ZM11 16.9978H7V18.9978H11V16.9978ZM17 18.9978V16.9978H13V18.9978H17Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-calculator-filled')
export default class CalculatorFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'calculator-filled',
    }
  }
}
